import { SrOrderStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import { Badge } from '@plato/ui-legacy/components/list-views/badge';
import { useTranslation } from 'react-i18next';

type Props = {
    status: SrOrderStatus;
    type: SrSalesOrderType;
    className?: string;
};

export function OrderStatusBadge({ status, type, className }: Props) {
    const { t } = useTranslation('order-status');
    const getStatusLabel = (status: SrOrderStatus): string => {
        switch (status) {
            case SrOrderStatus.OPEN:
                return t('OPEN');
            case SrOrderStatus.PARTIALLY_BILLED:
                return t('PARTIALLY_BILLED');
            case SrOrderStatus.BILLED:
                return t('BILLED');
            case SrOrderStatus.OPEN_IN_PICKING:
                return t('OPEN_IN_PICKING');
            case SrOrderStatus.PROCESSED_INTERNALLY:
                return t('PROCESSED_INTERNALLY');
            case SrOrderStatus.CANCELLED:
                return t('CANCELLED');
            case SrOrderStatus.PARTIALLY_RECEIVED:
                return t('PARTIALLY_RECEIVED');
            case SrOrderStatus.RECEIVED:
                return t('RECEIVED');
            case SrOrderStatus.LOST:
                return t('LOST');
            case SrOrderStatus.REVISED:
                return t('REVISED');
            case SrOrderStatus.COMPLETED:
                return t('COMPLETED');
            case SrOrderStatus.UNKNOWN:
                return t('UNKNOWN');
            case SrOrderStatus.RELEASED_FOR_DELIVERY:
                return t('RELEASED_FOR_DELIVERY');
            case SrOrderStatus.RETURNED:
                return t('RETURNED');
            case SrOrderStatus.SHIPPED:
                return t('SHIPPED');
            case SrOrderStatus.PARTIALLY_PICKED:
                return t('PARTIALLY_PICKED');
            case SrOrderStatus.PICKED:
                return t('PICKED');
            case SrOrderStatus.PARTIALLY_SHIPPED:
                return t('PARTIALLY_SHIPPED');
            case SrOrderStatus.PENDING:
                return t('PENDING');
            case SrOrderStatus.OTHER:
                return t('OTHER');
        }
    };
    const color = getOrderStatusColor(type, status);

    return (
        <Badge color={color} className={className}>
            {getStatusLabel(status)}
        </Badge>
    );
}

type StatusColor = 'yellow' | 'orange' | 'green' | 'red' | 'blue' | 'neutral';

function getOrderStatusColor(type: SrSalesOrderType, status: SrOrderStatus): StatusColor {
    if (type === SrSalesOrderType.QUOTE) {
        switch (status) {
            case SrOrderStatus.LOST:
                return 'red';
            case SrOrderStatus.OPEN:
                return 'yellow';
            case SrOrderStatus.PARTIALLY_RECEIVED:
                return 'blue';
            case SrOrderStatus.RECEIVED:
                return 'green';
            default:
                return 'neutral';
        }
    }
    switch (status) {
        case SrOrderStatus.BILLED:
        case SrOrderStatus.PROCESSED_INTERNALLY:
            return 'green';
        case SrOrderStatus.CANCELLED:
            return 'red';
        case SrOrderStatus.OPEN:
            return 'yellow';
        case SrOrderStatus.OPEN_IN_PICKING:
        case SrOrderStatus.PARTIALLY_PICKED:
        case SrOrderStatus.PICKED:
            return 'orange';
        case SrOrderStatus.PARTIALLY_BILLED:
            return 'blue';
        default:
            return 'neutral';
    }
}
